import Vue from 'vue';
import Vuex from 'vuex';

// import module
import city from './modules/city';
import auth from './modules/auth';
import register from './modules/register';
import rfq from './modules/rfq';
import contract from './modules/contract';
import instantQuote from './modules/instantQuote';
import settingAccount from './modules/settings/account';
import settingSaf from './modules/settings/saf';
import settingCompany from './modules/settings/company';
import settingDocs from './modules/settings/documents';
import settingUsers from './modules/settings/users';
import shipment from './modules/shipment';
import instantprice from './modules/instantprice';
import book from './modules/book';
import contact from './modules/contact';
import chat from './modules/chat';
import file from './modules/file';
import payment from './modules/payment';
import merchantlist from './modules/merchantlist';
import fileRfq from './modules/file/rfq';
import bookmark from './modules/bookmark';
import promo from './modules/promo';
import fileContract from './modules/file/contract';
import invitation from './modules/invitation';
import andalinpoint from './modules/andalinpoint';
import alibabaPayment from './modules/alibabaPayment';
import address from './modules/address';
import log from './modules/log';
import rate from './modules/rate';
import sales from './modules/sales';
import dashboard from './modules/dashboard';
import requestList from './modules/requestlist';
import insurance from './modules/insurance';
import vesselSchedule from './modules/vessel-schedule';
import tms from './modules/tms';
import warehouse from './modules/warehouse';
import vesselCharter from './modules/vessel-charter';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    city,
    register,
    rfq,
    contract,
    instantQuote,
    settingAccount,
    settingSaf,
    settingCompany,
    settingUsers,
    shipment,
    instantprice,
    book,
    settingDocs,
    contact,
    chat,
    file,
    payment,
    merchantlist,
    fileRfq,
    bookmark,
    promo,
    fileContract,
    invitation,
    andalinpoint,
    alibabaPayment,
    address,
    log,
    rate,
    sales,
    dashboard,
    requestList,
    insurance,
    vesselSchedule,
    tms,
    warehouse,
    vesselCharter
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js